import * as React from 'react';
import * as c from 'models/constants';
import { Dispatch, connect } from 'react-redux';
import { ITranslateProps, InjectedFormProps } from 'models/common';
import { IStore } from 'redux/IStore';
import { reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import {
	BookingItemToUpdateRequest,
	IAppointmentWithCustomer,
	IManualBookingModalProps,
} from 'models/shop/appointments';
import { MainBookingScreen } from './MainBookingScreen';
import { SelectCustomerScreen } from './SelectCustomerScreen';
import { RecurringEventScreen } from './RecurringEventScreen';
import { AddEditCustomerScreen, IAddEditCustomerScreenQueryParams } from './AddEditCustomerScreen';
import { ISelectServiceScreenQueryParams, SelectServiceScreen } from './SelectServiceScreen';
import {
	addMultipleURLSearchParams,
	addURLSearchParams,
	deleteURLSearchParams,
	readMultipleURLSearchParams,
} from 'helpers/common';
import { closeModal, showModal } from 'redux/modules/modal';
import { IManualBookingFormData } from 'models/shop/manualbooking';
import { getOfficeServiceGroups } from 'redux/modules/shop/serviceGroups';
import { getBookingTemplatesById, getBookingTemplatesByOffice } from 'redux/modules/shop/bookingtemplates';
import { IServiceGroups } from 'models/shop/serviceGroups';
import { IShopBookingTemplates } from 'models/shop/shopBookingTemplates';
import { EditServiceScreen, IEditServiceScreenQueryParams } from './EditServiceScreen';
import { addEditBatchDiscountStrategies, getDiscountStrategies } from 'redux/modules/shop/discountStrategies';
import { getBookingAvailability } from 'redux/modules/bookappointment';
import {
	IAddBookingItemRequest,
	IBookingAvailabiltyResponse,
	IFormAddBookingItemRequest,
} from 'models/bookappointment';
import {
	generateFirstRecurringBookingItems,
	generateFormBookingItems,
	generateRecurringBookingItems,
	getPriceFromBookingItem,
	getRecurringFrequency,
} from './helpers';
import { getShopOrder } from 'redux/modules/shop/shopordercard';
import { getOneShopCustomer, updateShopCustomer } from 'redux/modules/shop/shopcard';
import { CancelAppointmentScreen } from './CancelAppointmentScreen';
import moment = require('moment');
import { AddEditBlockedTimeScreen } from './AddEditBlockedTime';
import { IBookingTimeTable } from 'models/shop/bookingtimetables';
import { IRescheduleProps } from 'models/shop/schedule';
import { UpdateRecurringSelectionScreen } from './UpdateRecurringSelectionScreen';
import { IManualOrderRequest, IOrderItem, IShopOrder } from 'models/orders/order';
import {
	addManualBookingItemToShoppingCart,
	clearAppointmentsErrors,
	createManualOrder,
	getAppointments,
	groupRecurringAppointments,
	updateAppointmentsOnShopOrder,
} from 'redux/modules/shop/appointments';
import {
	clearFormData,
	clearShoppingBasket,
	manualBookingGetShoppingBasket,
	manualBookingUpdateShoppingBasket,
} from 'redux/modules/cart';
import { ICustomer } from 'models/shop/customer';
import { IDiscountStrategy } from 'models/shop/discountStrategies';
import { setStatus } from 'redux/modules/shop/orders';
import { OrderPaymentStatus, OrderStatus } from 'models';
import { IShoppingBasketBookingItem, IShoppingBasketItem } from 'models/cart/shoppingbasketitem';
import { IShoppingBasket } from 'models/cart/shoppingbasket';
import { IOfficeMember } from 'models/shop/members';
import { RedButton, WhiteButton } from 'components';
require('./style.scss');
export interface InjectedManualBookingModalProps {
	/**
	 * Sets to a manual booking screen and sets the provided parameters
	 * @param screen
	 * @param queryParams the parameters query that get set when changing a screen
	 */
	setScreen(screen: ManualBookingScreen.AddEditCustomer, queryParams?: IAddEditCustomerScreenQueryParams);
	setScreen(screen: ManualBookingScreen.EditService, queryParams?: IEditServiceScreenQueryParams);
	setScreen(screen: ManualBookingScreen.SelectService, queryParams?: ISelectServiceScreenQueryParams);
	setScreen(screen: ManualBookingScreen, queryParams?: any);

	closeModal?: () => void;
	startCloseModal?: () => void;

	appointment?: IAppointmentWithCustomer;
	mode?: 'add' | 'edit' | 'editBlockedTime';

	shopId?: string;
	officeId?: string;
	time?: string;
	timezone?: string;
	resourceId?: string;
	serviceGroups?: IServiceGroups;
	shopBookingTemplates?: IShopBookingTemplates;

	rescheduleProps?: IRescheduleProps;

	// Edit blocked time props
	endTime?: string;
	timetables?: IBookingTimeTable[];
	description?: string;

	submitAddManualBooking(): Promise<any>;
	submitEditManualBooking(): Promise<any>;
}

export interface InjectedQueryParams {
	time?: string;
	timezone?: string;
	resourceId?: string;
	mode?: 'add' | 'edit' | 'editBlockedTime';
	shopOrderId?: string;
}

interface IOwnProps extends IManualBookingModalProps {}

type IProps = IOwnProps &
	ReturnType<typeof stateToProps> &
	ReturnType<typeof dispatchToProps> &
	ITranslateProps &
	InjectedFormProps;

export enum ManualBookingScreen {
	Main = 'main',
	SelectCustomer = 'select-customer',
	AddEditCustomer = 'add-edit-customer',
	AdvancedOptions = 'advanced-options',
	SelectService = 'select-service',
	RecurringEvent = 'recurring-event',
	EditService = 'edit-service',
	CancelAppointment = 'cancel-appointment',
	AddEditBlockedTime = 'add-edit-blocked-time',
	UpdateRecurringSelection = 'update-recurring-selection-screen',
}

interface IState {
	screen: ManualBookingScreen;
}

const screens = {
	[ManualBookingScreen.Main]: MainBookingScreen,
	[ManualBookingScreen.SelectCustomer]: SelectCustomerScreen,
	[ManualBookingScreen.AddEditCustomer]: AddEditCustomerScreen,
	[ManualBookingScreen.SelectService]: SelectServiceScreen,
	[ManualBookingScreen.RecurringEvent]: RecurringEventScreen,
	[ManualBookingScreen.EditService]: EditServiceScreen,
	[ManualBookingScreen.CancelAppointment]: CancelAppointmentScreen,
	[ManualBookingScreen.AddEditBlockedTime]: AddEditBlockedTimeScreen,
	[ManualBookingScreen.UpdateRecurringSelection]: UpdateRecurringSelectionScreen,
};

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManualBookingModalComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.setScreen = this.setScreen.bind(this);
		this.screenProps = this.screenProps.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.calculateTotalPriceAndChangeField = this.calculateTotalPriceAndChangeField.bind(this);

		// functions for submitting manual order add/edit
		this.addNewManualOrder = this.addNewManualOrder.bind(this);
		this.submitManualBookingRequest = this.submitManualBookingRequest.bind(this);
		this.submitManualBookingUpdateRequest = this.submitManualBookingUpdateRequest.bind(this);
		this.isPriceOriginal = this.isPriceOriginal.bind(this);
		this.startCloseModal = this.startCloseModal.bind(this);

		this.state = {
			screen: ManualBookingScreen.Main,
		};
	}

	componentDidMount(): void {
		const {
			time,
			timezone,
			resourceId,
			bookingTemplates,
			serviceGroups,
			discountStrategiesShopId,
			shopOrderCard,
			getBookingTemplatesById,
			bookingTemplatesById,
		} = this.props;

		this.props.clearCartFormData();
		this.props.clearAppointmentsErrors();

		if (bookingTemplatesById == null || bookingTemplates?.[0]?.officeId !== this.props.officeId) {
			this.props.getBookingTemplatesByOffice(this.props.officeId);
		}
		if (serviceGroups.serviceGroups?.[0]?.officeId !== this.props.officeId) {
			this.props.getOfficeServiceGroups(this.props.officeId);
		}
		if (!discountStrategiesShopId || discountStrategiesShopId !== this.props.shopId) {
			this.props.getDiscountStrategies(this.props.shopId);
		}

		const searchParams = new URLSearchParams(window.location.search);
		const mode = this.props.mode || searchParams.get('mode');

		if (mode === 'edit') {
			const shopOrderId = this.props.appointment?.shopOrder?.id || searchParams.get('shopOrderId');
			const timeFromProps = moment(this.props.time || searchParams.get('time'));
			// Build edit items here
			const generateFormValues = (shopOrderRes?: IShopOrder): Promise<any> => {
				const shopOrder = shopOrderRes || shopOrderCard?.shopOrder;
				this.props.change('customerId', shopOrder.customerId);
				this.props.change('appointmentNote', shopOrder.note);

				// if drag and drop then true otherwise set later if recurring event before saving
				this.props.change('updateOnlySelectedItem', this.props?.updateOnlySelectedItem);

				const applyReschedulePropsToItems = (items) => {
					// if drag and drop then generate item times based on its start time
					if (this.props?.rescheduleProps?.orderItemId && this.props?.rescheduleProps?.startTimeMoment && items) {
						const bookingItem = items.find((item) => item.id == this.props?.rescheduleProps?.orderItemId);
						const bookedOrderItemData = bookingItem.childrenAddBookingItemRequest.find(
							(item) => item.id == this.props?.rescheduleProps?.bookedOrderItemDataId,
						);
						// is bundle
						if (bookedOrderItemData) {
							if (
								this.props?.rescheduleProps?.resourceId &&
								bookingTemplates
									?.find((bt) => bt.id == bookedOrderItemData.bookingTemplateId)
									?.resources.find(
										(x) =>
											x == this.props?.rescheduleProps?.resourceId ||
											(x as IOfficeMember).id == this.props?.rescheduleProps?.resourceId,
									)
							) {
								bookedOrderItemData.resourceId = this.props?.rescheduleProps?.resourceId;
							}
							const diff =
								moment(this.props?.rescheduleProps?.startTimeMoment).unix() -
								moment(bookedOrderItemData.schedule).unix();
							bookingItem.childrenAddBookingItemRequest.forEach((item) => {
								item.schedule = moment(item.schedule).add(diff, 'seconds').toISOString();
							});
							bookingItem.schedule = moment(bookingItem.schedule).add(diff, 'seconds').toISOString();
						} else {
							if (
								this.props?.rescheduleProps?.resourceId &&
								bookingTemplates
									?.find((bt) => bt.id == bookingItem.bookingTemplateId)
									?.resources.find(
										(x) =>
											x == this.props?.rescheduleProps?.resourceId ||
											(x as IOfficeMember).id == this.props?.rescheduleProps?.resourceId,
									)
							) {
								bookingItem.resourceId = this.props?.rescheduleProps?.resourceId;
							}
							bookingItem.schedule = moment(this.props?.rescheduleProps?.startTimeMoment).toISOString();
						}
						this.props.change('isEditModeEnabled', true);
					}
				};

				return generateFormBookingItems(shopOrder, bookingTemplates, getBookingTemplatesById).then(
					(bookingItems: IFormAddBookingItemRequest[]) => {
						// if recurring events
						if (shopOrder?.items?.[0]?.recurringBookingId) {
							// filter out items in the past (only update clicked item and future ones)
							const dayFromProps = timeFromProps.startOf('day');
							const upcomingRecurringItems = bookingItems.filter((ri) =>
								moment(ri.schedule).isSameOrAfter(dayFromProps),
							);

							// filter out all future items and grab first that is the closest to the clicked time
							const firstRecurringItems = generateFirstRecurringBookingItems(upcomingRecurringItems);

							// generate frequency and ends at values based on existing items
							const allFirstBookingTemplateItemSchedules: string[] = upcomingRecurringItems
								.filter((cri) => cri.bookingTemplateId === firstRecurringItems[0].bookingTemplateId)
								.map((crim) => crim.schedule as string);

							applyReschedulePropsToItems(firstRecurringItems);

							if (!this.props?.updateOnlySelectedItem) {
								const recurringFrequency = getRecurringFrequency(allFirstBookingTemplateItemSchedules);
								this.props.change('frequency', recurringFrequency);
								this.props.change('endsAt', allFirstBookingTemplateItemSchedules?.length);
							}

							// always display only currently seen form items' prices
							this.calculateTotalPriceAndChangeField(firstRecurringItems);

							this.props.change('bookingItems', firstRecurringItems);

							// for cancellation
							this.props.change('cancellationBookingItems', firstRecurringItems);

							// items to delete from current recurring order if updating / cancelling all upcoming appointment items (splits into 2 orders if updating)
							this.props.change('upcomingRecurringBookingItems', upcomingRecurringItems);
							this.props.change('isRecurringEvent', true);

							const sortedRecurringItems = upcomingRecurringItems.sort((a, b) =>
								moment(a.schedule).isBefore(moment(b.schedule)) ? 1 : -1,
							);
							const lastScheduleItem = sortedRecurringItems[0].schedule;
							this.props.change('lastTime', lastScheduleItem);
						} else {
							applyReschedulePropsToItems(bookingItems);
							if (bookingItems?.length) {
								this.calculateTotalPriceAndChangeField(bookingItems);
							}
							this.props.change('bookingItems', bookingItems);
						}
					},
				);
			};

			this.props.getShopOrder(shopOrderId).then((orderRes) => {
				const shopOrder: IShopOrder = orderRes?.payload?.shopOrder;
				this.props
					.getOneShopCustomer(shopOrder.customerId)
					.then(() => {
						const selectedCustomer: ICustomer = this.props?.shopCard?.selectedCustomer
							? JSON.parse(JSON.stringify(this.props.shopCard.selectedCustomer))
							: null;

						// Check if walk-in customer has it's isEmailNotificationEnabled enabled and disabled it so it does not send unneccessary emails
						if (
							selectedCustomer?.email === 'walk-in@glossiq.com' &&
							selectedCustomer?.isEmailNotificationEnabled === true
						) {
							selectedCustomer.isEmailNotificationEnabled = false;

							this.props.updateShopCustomer(selectedCustomer).then(() => {
								console.info('Successfully updated walk-in customer');
							});
						}
					})
					.catch((err) => {
						console.error(err);
					});

				generateFormValues(shopOrder);

				if (
					(mode === 'edit' && shopOrder?.order?.message?.includes('Original paid order id') === true) ||
					(mode === 'edit' && shopOrder?.order?.paymentStatus === OrderPaymentStatus.Verified)
				) {
					this.props.change('isPaidOnline', true);
				} else {
					this.props.change('isPaidOnline', false);
				}
			});
		}

		if (typeof window !== 'undefined') {
			const resourceIdParam = resourceId || searchParams.get('resourceId');
			const timezoneParam = timezone || searchParams.get('timezone');
			const timeParam = time || searchParams.get('time');

			const urlParamsToAdd = [
				{ name: 'manual-booking', value: 'true' },
				{ name: 'time', value: timeParam },
				{ name: 'timezone', value: timezoneParam },
				{ name: 'resourceId', value: resourceIdParam },
				{ name: 'mode', value: mode },
			];

			if (mode == 'edit' && this.props.appointment?.shopOrder?.id) {
				urlParamsToAdd.push({ name: 'shopOrderId', value: this.props.appointment?.shopOrder?.id });
			}

			addMultipleURLSearchParams(urlParamsToAdd);

			const screen = searchParams.get('screen') as ManualBookingScreen;
			if (screen) this.setState({ screen });
		}
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (
			JSON.stringify(prevProps?.currentFormValues?.bookingItems) !==
				JSON.stringify(this.props?.currentFormValues?.bookingItems) ||
			prevProps?.currentFormValues?.frequency !== this.props?.currentFormValues?.frequency ||
			prevProps?.currentFormValues?.endsAt !== this.props?.currentFormValues?.endsAt ||
			prevProps?.currentFormValues?.endsAtDate !== this.props?.currentFormValues?.endsAtDate ||
			prevProps?.currentFormValues?.dateOfTheAppointment !== this.props.currentFormValues.dateOfTheAppointment ||
			prevProps?.currentFormValues?.startTimeOfTheAppointment !== this.props.currentFormValues.startTimeOfTheAppointment
		) {
			const { currentFormValues } = this.props;
			const searchParams = new URLSearchParams(window.location.search);
			const mode = this.props.mode || searchParams.get('mode');
			let recurringBookingItems: IFormAddBookingItemRequest[] = [];

			if (
				mode === 'edit' &&
				!currentFormValues?.isEditModeEnabled &&
				currentFormValues?.upcomingRecurringBookingItems?.length
			) {
				recurringBookingItems = JSON.parse(JSON.stringify(currentFormValues?.upcomingRecurringBookingItems));
			} else if (mode === 'add' || (mode === 'edit' && currentFormValues?.isEditModeEnabled)) {
				recurringBookingItems = generateRecurringBookingItems(currentFormValues);
			}

			// always display only currently seen form items' prices
			this.calculateTotalPriceAndChangeField(currentFormValues.bookingItems);

			if (recurringBookingItems?.length) {
				this.props
					.getBookingAvailability(recurringBookingItems)
					.then((res: { message: string; result: IBookingAvailabiltyResponse[]; status: 'ok' | 'error' }) => {
						if (res?.status === 'ok') {
							// filter booking availability response into an one dimensional array of unavailable reasons
							const filteredUnavailableReasons = res?.result
								? res.result
										.filter(
											(obj) =>
												Object.prototype.hasOwnProperty.call(obj, 'unavailableReasons') &&
												Array.isArray(obj?.unavailableReasons) &&
												obj?.unavailableReasons?.length > 0,
										)
										.map((obj2) => obj2.unavailableReasons)
										.reduce((acc, curr) => acc.concat(curr), [])
								: [];

							this.props.change('bookingItemConflicts', filteredUnavailableReasons);

							// get last schedule item
							if (this.props.currentFormValues?.frequency && this.props.currentFormValues?.endsAt) {
								const sortedRecurringItems = recurringBookingItems.sort((a, b) =>
									moment(a.schedule).isBefore(moment(b.schedule)) ? 1 : -1,
								);
								const lastScheduleItem = sortedRecurringItems[0].schedule;
								this.props.change('lastTime', lastScheduleItem);
							}
						}
					})
					.catch((err) => console.error(err));
			} else {
				this.props.change('totalPrice', '');
			}
		}
	}

	private startCloseModal() {
		const { showModal, t } = this.props;
		const dialogContent = (
			<div className="manualBookingCloseConfirmationModal__textWrapper">
				<h2 className="manualBookingCloseConfirmationModal__title">
					{t('ManualBookingModal_CloseModal_ConfirmationTitle')}
				</h2>
				<p className="manualBookingCloseConfirmationModal__text">
					{t('ManualBookingModal_CloseModal_ConfirmationMessage')}
				</p>
			</div>
		);

		const confirmFnc = (confirm: boolean) => {
			if (confirm === true) {
				this.closeModal();
				this.props.closeConfirmationModal();
			} else {
				this.props.closeConfirmationModal();
			}
		};

		showModal('ConfirmationDialog', {
			customFooterContent: (
				<>
					<WhiteButton onClick={() => confirmFnc(false)}>
						<span className="manualBookingCloseConfirmationModal__desktopLeftButton">
							{t('ManualBookingModal_CloseModal_LeftButtonDesktop')}
						</span>{' '}
						<span className="manualBookingCloseConfirmationModal__mobileLeftButton">
							{t('ManualBookingModal_CloseModal_LeftButtonMobile')}
						</span>{' '}
					</WhiteButton>
					<RedButton onClick={() => confirmFnc(true)}>
						<span className="manualBookingCloseConfirmationModal__desktopRightButton">
							{t('ManualBookingModal_CloseModal_RightButtonDesktop')}
						</span>{' '}
						<span className="manualBookingCloseConfirmationModal__mobileRightButton">
							{t('ManualBookingModal_CloseModal_RightButtonMobile')}
						</span>
					</RedButton>
				</>
			),
			confirmAction: (confirm: boolean) => confirmFnc(confirm),
			content: dialogContent,
			customModalClassName: 'manualBookingCloseConfirmationModal',
		});
	}

	private addNewManualOrder = (
		itemsToAdd: IFormAddBookingItemRequest[],
		orderRequestData?: Partial<IManualOrderRequest>,
	): Promise<any> => {
		const {
			currentFormValues,
			manageShop,
			shopId,
			addManualBookingItemToShoppingCart,
			getAppointments,
			addAppointmentNoteOnShopOrder,
			manualBookingUpdateShoppingBasket,
			addEditBatchDiscountStrategies,
			groupRecurringAppointments,
			createManualOrder,
			clearShoppingBasket,
		} = this.props;

		const allBookingItemsToAdd: IFormAddBookingItemRequest[] = itemsToAdd;
		const bookingItemsToAdd: IFormAddBookingItemRequest[] = JSON.parse(JSON.stringify(allBookingItemsToAdd));
		const firstBookingItem = bookingItemsToAdd.shift();

		let customer: ICustomer = this.customerData;

		// Walk-in customer
		if (!customer) {
			customer = {
				email: 'walk-in@glossiq.com',
				name: 'GLOSSIQ WALK-IN',
			};
		}

		const discountStrategiesToAdd: IDiscountStrategy[] = [];

		const generateDiscountStrategyData = (item: IShoppingBasketBookingItem, discountPrice: number) => {
			const discountStrategy: IDiscountStrategy = {
				shopId: item.shopId,
				title: item.productName,
				description: item.name,
				validFrom: moment().subtract(1, 'hour').toISOString(),
				validTo: moment(item.schedule).add(1, 'day').startOf('hour').toISOString(),
				isDiscountPercentage: false,
				discountValue: discountPrice,
				type: 0,
				isActive: true,
				productId: item.productId,
				officeId: item.officeId,
				isSellingPrice: true, // always generate as selling price (can be higher than original booking template price)
			};

			discountStrategiesToAdd.push(discountStrategy);
		};

		// add first booking item to cart to initiate shopping basket
		return addManualBookingItemToShoppingCart(firstBookingItem)
			.then((scRes: { status: 'ok' | 'error'; result: IShoppingBasket }) => {
				if (scRes.status === 'ok') {
					// if only one item
					if (bookingItemsToAdd.length === 0 && !currentFormValues?.appointmentNote?.length) {
						// get shopping basket before creating discounts
						return this.props.manualBookingGetShoppingBasket().then((basketRes) => {
							if (basketRes.status === 'ok') {
								const basketItems: IShoppingBasketItem[] = basketRes?.response?.items;

								if (firstBookingItem?.discountPrice != undefined) {
									generateDiscountStrategyData(basketItems[0], firstBookingItem.discountPrice);
								}

								if (discountStrategiesToAdd.length) {
									// create discount strategy
									return addEditBatchDiscountStrategies(discountStrategiesToAdd, undefined, shopId).then(() => {
										// create order after adding discounts
										return createManualOrder(customer, manageShop.shop.currencyKey, orderRequestData).then(
											(orderRes) => {
												const shopOrder = orderRes.result.shopOrders[0];
												// add appointment note if any
												return addAppointmentNoteOnShopOrder({
													...shopOrder,
													note: currentFormValues?.appointmentNote || '',
												}).then(() => {
													return clearShoppingBasket().then(() => {
														return getAppointments().then(() => {
															return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
														});
													});
												});
											},
										);
									});
								} else {
									// create order
									return createManualOrder(customer, manageShop.shop.currencyKey, orderRequestData).then((orderRes) => {
										const shopOrder = orderRes.result.shopOrders[0];
										// add appointment note if any
										return addAppointmentNoteOnShopOrder({
											...shopOrder,
											note: currentFormValues?.appointmentNote || '',
										}).then(() => {
											return clearShoppingBasket().then(() => {
												return getAppointments().then(() => {
													return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
												});
											});
										});
									});
								}
							}
						});
					} else {
						// else update shopping cart with other items
						bookingItemsToAdd.forEach((bita) => {
							bita.includeUnavailableResources = true;
						});
						return manualBookingUpdateShoppingBasket(scRes.result.id, bookingItemsToAdd)
							.then((basketRes) => {
								if (basketRes?.error) {
									return Promise.reject(basketRes?.message);
								}

								//!!! manualBookingUpdateShoppingBasket DOES NOT APPLY BOOKING TEMPLATE DISCOUNTS ON RETURNED ITEMS
								//-> Prices and total are not accurate!!!
								const basketItems: IShoppingBasketItem[] = basketRes?.items;
								// generate discount strategies, booking items order must be the same by shop order items (both should be sorted by schedule)
								basketItems.forEach((bi, idx) => {
									if (allBookingItemsToAdd?.[idx]?.discountPrice != undefined) {
										generateDiscountStrategyData(bi, allBookingItemsToAdd[idx].discountPrice);
									}
								});

								if (discountStrategiesToAdd.length) {
									// create discount strategy
									return addEditBatchDiscountStrategies(discountStrategiesToAdd, undefined, shopId).then(() => {
										// if recurring
										if (currentFormValues?.frequency && currentFormValues?.endsAt) {
											// send isSendOrderConfirmedSMSNotificationDisabled flag to BE so it does not send confirmation SMS messages
											orderRequestData.isSendOrderConfirmedSMSNotificationDisabled = true;

											// create order
											return createManualOrder(customer, manageShop.shop.currencyKey, orderRequestData).then(
												(orderRes) => {
													const orderItems = orderRes.result.items;

													const shopOrder = orderRes.result.shopOrders[0];
													// add appointment note if any
													return addAppointmentNoteOnShopOrder({
														...shopOrder,
														note: currentFormValues?.appointmentNote || '',
													}).then(() => {
														return groupRecurringAppointments(orderItems).then(() => {
															return clearShoppingBasket().then(() => {
																return getAppointments().then(() => {
																	return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
																});
															});
														});
													});
												},
											);
										} else {
											// create order
											return createManualOrder(customer, manageShop.shop.currencyKey, orderRequestData).then(
												(orderRes) => {
													const shopOrder = orderRes.result.shopOrders[0];
													// add appointment note if any
													return addAppointmentNoteOnShopOrder({
														...shopOrder,
														note: currentFormValues?.appointmentNote || '',
													}).then(() => {
														return clearShoppingBasket().then(() => {
															return getAppointments().then(() => {
																return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
															});
														});
													});
												},
											);
										}
									});
								} else {
									// if recurring
									if (currentFormValues?.frequency && currentFormValues?.endsAt) {
										// send isSendOrderConfirmedSMSNotificationDisabled flag to BE so it does not send confirmation SMS messages
										orderRequestData.isSendOrderConfirmedSMSNotificationDisabled = true;

										// create order
										return createManualOrder(customer, manageShop.shop.currencyKey, orderRequestData).then(
											(orderRes) => {
												const orderItems = orderRes.result.items;
												const shopOrder = orderRes.result.shopOrders[0];
												return addAppointmentNoteOnShopOrder({
													...shopOrder,
													note: currentFormValues?.appointmentNote || '',
												}).then(() => {
													// group recurring event
													return groupRecurringAppointments(orderItems).then(() => {
														return clearShoppingBasket().then(() => {
															return getAppointments().then(() => {
																return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
															});
														});
													});
												});
											},
										);
									} else {
										// create order
										return this.props
											.createManualOrder(customer, manageShop.shop.currencyKey, orderRequestData)
											.then((orderRes) => {
												const shopOrder = orderRes.result.shopOrders[0];
												// add appointment note if any
												return addAppointmentNoteOnShopOrder({
													...shopOrder,
													note: currentFormValues?.appointmentNote || '',
												}).then(() => {
													return clearShoppingBasket().then(() => {
														return getAppointments().then(() => {
															return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
														});
													});
												});
											});
									}
								}
							})
							.catch((err) => Promise.reject(err));
					}
				}
			})
			.catch((err) => Promise.reject(err));
	};

	private submitManualBookingRequest = (): Promise<any> => {
		const { currentFormValues } = this.props;
		if (currentFormValues?.bookingItems?.filter((x) => !x.deleted)?.length) {
			const allBookingItemsToAdd: IFormAddBookingItemRequest[] = generateRecurringBookingItems(currentFormValues);
			return this.addNewManualOrder(allBookingItemsToAdd, {});
		}
		return Promise.reject();
	};

	private submitManualBookingUpdateRequest = (): Promise<any> => {
		const { shopOrderCard, updateAppointmentsOnShopOrderEdit, getAppointments } = this.props;
		const { bookingItems } = this.props.currentFormValues;
		const existingNonDeletedItems: IFormAddBookingItemRequest[] = bookingItems.filter(
			(bi) => !bi?.deleted && bi.productId,
		);

		let itemsToUpdate: BookingItemToUpdateRequest[] = [];

		// check if items need to be updated or if a new order needs to be created if prices changed
		shopOrderCard?.shopOrder?.items?.forEach((item) => {
			const formItem = bookingItems.find((bi) => bi.productId === item.productId);
			if (this.isPriceOriginal(formItem)) {
				let shouldUpdate = false;
				const oldBookingTemplate = this.props.bookingTemplates.find((bt) => bt.sku === item.productSKU);
				// put item in update array only if conditions are met
				if (
					!moment(item.productSchedule).isSame(moment(formItem.schedule)) ||
					formItem.bookingTemplateId !== oldBookingTemplate.id ||
					formItem.resourceId !== item.bookedOrderItemDatas[0]?.resourceId ||
					formItem.duration !== item.productDuration
				) {
					shouldUpdate = true;
				}

				// if bundle check if children resources changed
				if (formItem?.childrenAddBookingItemRequest?.length > 0) {
					const bookedOrderItemData = [...item.bookedOrderItemDatas];

					// Sort by start times
					const sortedBookedOrderItemData = bookedOrderItemData.sort((a, b) => {
						if (moment(a.startTime).isBefore(b.startTime)) {
							return -1;
						} else if (moment(a.startTime).isAfter(b.startTime)) {
							return 1;
						} else {
							return 0;
						}
					});

					for (let idx = 0; idx < formItem.childrenAddBookingItemRequest.length; idx++) {
						if (
							sortedBookedOrderItemData?.[idx]?.resourceId &&
							formItem.childrenAddBookingItemRequest[idx].resourceId !== sortedBookedOrderItemData[idx].resourceId
						) {
							shouldUpdate = true;
						}
					}
				}

				// add to update if above conditions met
				if (shouldUpdate) {
					// bookingId === productId
					itemsToUpdate.push({ ...formItem, bookingId: formItem.productId });
				}
			} else {
				// If order item had a discount applied we want to apply the same price if user did not set the price yet
				if (formItem && formItem?.discountPrice == undefined) {
					formItem.discountPrice = item.price;
				}
			}
		});

		let itemIdsToRemove = bookingItems.filter((bi) => bi?.deleted).map((bi2) => bi2.productId);
		let itemsToAdd: IFormAddBookingItemRequest[] = bookingItems.filter((bi) => !bi?.deleted && !bi?.productId);
		let shouldRejectOrder: boolean = false;
		const itemsToAddToNewOrder: IFormAddBookingItemRequest[] = [...itemsToAdd];

		// if updating recurring event
		if (shopOrderCard?.shopOrder?.items?.[0]?.recurringBookingId) {
			// if update only selected flag is enabled then remove existing item id
			if (this.props.currentFormValues.updateOnlySelectedItem) {
				existingNonDeletedItems.forEach((itu) => {
					itemIdsToRemove.push(itu.productId);
				});
			} else {
				// else remove all upcoming items
				this.props.currentFormValues?.upcomingRecurringBookingItems?.forEach((urbi) => {
					itemIdsToRemove.push(urbi.productId);
				});
			}
			// Items to update need to go to add
			existingNonDeletedItems.forEach((itu) => {
				itemsToAddToNewOrder.push(itu);
			});

			// if all order items are to be deleted then cancel order and add new order with new recurring items, BE returns an error if you want to delete all order items!!!
			if (shopOrderCard?.shopOrder?.items?.length === itemIdsToRemove?.length) {
				shouldRejectOrder = true;
				itemIdsToRemove = [];
			}

			itemsToUpdate = [];
			itemsToAdd = [];
		}

		// check if any of the booking items contain a discount that is appliable
		// if the item has a booking template discount (if the price is not the same as original price) and the discountPrice is 0 then count as discount
		// so the item can be applied as original full price for the order
		// or if higher than 0
		const containsDiscounts = this.props.currentFormValues?.bookingItems?.some((bi) => {
			const biBookingTemplate = this.props.bookingTemplates.find((bt) => bi.bookingTemplateId === bt?.id);
			if (
				bi?.discountPrice != null &&
				((bi?.discountPrice === 0 && biBookingTemplate?.price !== biBookingTemplate?.originalPrice) ||
					bi?.discountPrice > 0)
			) {
				return true;
			} else {
				return false;
			}
		});

		// if not recurring and any items have appliable discounts then do not change any of the existing items, create new order instead
		if (!shopOrderCard?.shopOrder?.items?.[0]?.recurringBookingId && containsDiscounts) {
			itemsToUpdate = [];
			itemsToAdd = [];
			itemIdsToRemove = [];
		}

		// if the price of an item has changed then you have to create a new order and delete current one as product discount strategies can only be created on items inside the shopping basket!!!
		// booking template discounts also get deleted if you only update the shop order (new products are created) so we are forced to create a new order if we want discounted prices
		return updateAppointmentsOnShopOrderEdit(
			{
				...shopOrderCard?.shopOrder,
				note: this.props.currentFormValues?.appointmentNote || '',
				enableNotifications: this.props?.currentFormValues?.enableNotifications === false ? false : true,
			},
			itemsToUpdate,
			itemIdsToRemove,
			itemsToAdd,
		)
			.then((res) => {
				if (res?.status === 'ok') {
					// if updating existing recurring event and items changed
					if (itemsToAddToNewOrder?.length && shopOrderCard?.shopOrder?.items?.[0]?.recurringBookingId) {
						if (this.props.currentFormValues?.updateOnlySelectedItem) {
							// in this case do not generate recurring booking items as we are only updating the specific item
							const allBookingItemsToAdd: IFormAddBookingItemRequest[] = JSON.parse(
								JSON.stringify(this.props.currentFormValues.bookingItems),
							).filter((x) => !x?.deleted);

							// if only 1 recurring item left in entire recurring event then reject old and create new order
							if (shouldRejectOrder) {
								return this.props.rejectShopOrder(shopOrderCard?.shopOrder, '').then(() => {
									// create recurring event order
									return this.addNewManualOrder(allBookingItemsToAdd, {});
								});
							} else {
								// update only specific appointment
								return this.addNewManualOrder(allBookingItemsToAdd, {});
							}
						} else {
							// generate new recurring items based on the selected frequency and endsAt values
							const allBookingItemsToAdd: IFormAddBookingItemRequest[] = generateRecurringBookingItems({
								...this.props.currentFormValues,
								bookingItems: itemsToAddToNewOrder,
							});
							if (shouldRejectOrder) {
								// delete existing recurring order if the user edited the first recurring item as all items need to be changed in this case
								return this.props.rejectShopOrder(shopOrderCard?.shopOrder, '').then(() => {
									// create recurring event order
									return this.addNewManualOrder(allBookingItemsToAdd, {});
								});
							} else {
								return this.addNewManualOrder(allBookingItemsToAdd, {});
							}
						}
					} else if (
						(this.props.currentFormValues.frequency && this.props.currentFormValues.endsAt) ||
						containsDiscounts
					) {
						// if normal shop order turned into recurring event or discount price on any items
						// delete existing normal order
						return this.props.rejectShopOrder(shopOrderCard?.shopOrder, '').then(() => {
							const allBookingItemsToAdd: IFormAddBookingItemRequest[] = generateRecurringBookingItems(
								this.props.currentFormValues,
							);

							// if paid order before which includes booking template discounts then save the original order id
							let orderRequestData: Partial<IManualOrderRequest> = {};

							// TODO: REMOVE THIS LOGIC ONCE BOOKING TEMPLATE DISCOUNTS ARE APPLIED CORRECTLY ON UpdateShopOrder
							// currently if we update a paid order which contains discounts we lose the booking template discounts on products so we need to generate a new order (BE generates new products everytime we update)
							// when creating the new order we cancel the existing one (if paid this sends an email to notify us about the cancellation for refunds which could not be the case)
							// link the existing order to the new one through the order message field temporarily so we know the original paid order id
							if (shopOrderCard?.shopOrder?.order?.paymentStatus === OrderPaymentStatus.Verified) {
								orderRequestData = { message: `Original paid order id = ${shopOrderCard?.shopOrder?.orderId}` };
							}

							// if original paid order with discounts was created anew multiple times then take it's message to keep the order id
							if (
								shopOrderCard?.shopOrder?.order?.message !== null &&
								shopOrderCard?.shopOrder?.order?.message.includes('Original paid order id')
							) {
								orderRequestData = {
									message: shopOrderCard?.shopOrder?.order?.message,
								};
							}

							// create discounted normal order / recurring event order
							return this.addNewManualOrder(allBookingItemsToAdd, orderRequestData);
						});
					} else {
						// normal shop order that only needed to update (add, delete, update items without discounts / price change before and after)
						return getAppointments().then(() => {
							return Promise.resolve({ message: 'Completed successfully', status: 'ok' });
						});
					}
				} else {
					return Promise.reject(res?.message);
				}
			})
			.catch((err) => Promise.reject(err));
	};

	// If any item goes into false create new order as we need to create new discounts (discounts can only be created on shopping basket items before order is created)
	isPriceOriginal = (bookingItem: IFormAddBookingItemRequest): boolean => {
		if (!bookingItem) {
			return false;
		}

		const newBookingTemplate = this.props.bookingTemplates.find((bt) => bt.id === bookingItem.bookingTemplateId);

		// take original price, if a booking template has a discount and you want to update it BE will not apply it upon update
		// if a booking item had a discount before then when you update it's gone go you need to create a new order
		const nbtPrice = newBookingTemplate?.price?.toFixed(2);
		const nbtOriginalPrice = newBookingTemplate?.originalPrice?.toFixed(2);

		if (nbtOriginalPrice != nbtPrice) {
			return false;
		}

		const bookingItemPrice = bookingItem?.originalPrice?.toFixed(2);

		if (
			bookingItem?.discountPrice == 0 ||
			(bookingItem?.discountPrice == undefined && (bookingItemPrice === nbtPrice || !bookingItemPrice)) // booking item price is undefined if we changed booking template
		) {
			return true;
		} else {
			return false;
		}
	};

	calculateTotalPriceAndChangeField = (bookingItems: IFormAddBookingItemRequest[]) => {
		if (!bookingItems?.find((b) => !b?.deleted)) {
			this.props.change('totalPrice', '');
			return;
		}
		let totalPrice: number = 0;
		bookingItems
			.filter((b) => !b?.deleted)
			.forEach((bi) => {
				const bt = this.props.shopBookingTemplates?.servicesById?.[bi?.bookingTemplateId] || null;
				// TODO: check what happens if bt does not exist
				if (bt) {
					totalPrice += getPriceFromBookingItem(bi, bt);
				}
			});
		setTimeout(() => {
			this.props.change('totalPrice', totalPrice);
		}, 100);
	};

	setScreen: InjectedManualBookingModalProps['setScreen'] = (screen: ManualBookingScreen, queryParams: any) => {
		if (!queryParams) {
			addURLSearchParams('screen', screen);
		} else {
			addMultipleURLSearchParams([
				{ name: 'screen', value: screen },
				...Object.keys(queryParams).map((key) => ({ name: key, value: queryParams[key] })),
			]);
		}

		this.setState({ screen });
	};

	screenProps(): InjectedManualBookingModalProps {
		const {
			shopId,
			officeId,
			time,
			timezone,
			resourceId,
			mode,
			appointment,
			endTime,
			timetables,
			description,
			rescheduleProps,
		} = this.props;
		const urlParams = readMultipleURLSearchParams(['time', 'timezone', 'resourceId', 'mode']);

		return {
			mode,
			appointment,
			setScreen: this.setScreen,
			closeModal: this.closeModal,
			startCloseModal: this.startCloseModal,
			submitAddManualBooking: this.submitManualBookingRequest,
			submitEditManualBooking: this.submitManualBookingUpdateRequest,
			shopId,
			officeId,
			time,
			timezone,
			resourceId,
			rescheduleProps,
			endTime,
			timetables,
			description,
			...urlParams,
		};
	}

	closeModal() {
		this.props.closeModal('ManualBookingModal');
		deleteURLSearchParams(['manual-booking', 'resourceId', 'timezone', 'time', 'screen', 'mode', 'shopOrderId']);
	}

	get customerData(): ICustomer {
		const customerId = this.props.currentFormValues?.customerId;

		if (!customerId) {
			return;
		}

		if (this.props.shopCard.selectedCustomer?.id == this.props.currentFormValues?.customerId) {
			return this.props.shopCard.selectedCustomer;
		}

		return this.props.shopCard?.customers?.items?.find((customer) => customer?.id == customerId);
	}

	public render() {
		const ScreenComponent = screens[this.state.screen || ManualBookingScreen.Main];

		return <ScreenComponent {...this.screenProps()} />;
	}
}

const stateToProps = (state: IStore, ownProps: IOwnProps) => {
	const searchParams = new URLSearchParams(window.location.search);
	let rescheduleStartTime = undefined;

	if (ownProps?.rescheduleProps) {
		rescheduleStartTime = moment(ownProps.rescheduleProps.startTimeMoment).toISOString();
	}

	const initialValues: IManualBookingFormData = {
		dateOfTheAppointment: rescheduleStartTime || ownProps.time || searchParams.get('time'),
		startTimeOfTheAppointment: rescheduleStartTime || ownProps.time || searchParams.get('time'),
	};
	let currentFormValues: IManualBookingFormData = null;
	if (state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN] && state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values) {
		currentFormValues = state.form[c.FORM_NAME_MANUAL_BOOKING_PLAN].values;
	}

	return {
		currentFormValues,
		initialValues,
		shopCard: state.shopcard,
		manageShop: state.manageShop,
		shopOrderCard: state.shopOrderCard,
		bookingTemplates: state.shopBookingTemplates.services,
		bookingTemplatesById: state.shopBookingTemplates.servicesById,
		shopBookingTemplates: state.shopBookingTemplates,
		serviceGroups: state.serviceGroups,
		discountStrategiesShopId: state.discountStrategyReducer.shopId,
	};
};

const dispatchToProps = (dispatch: Dispatch<IStore> /*, ownProps: IOwnProps*/) => ({
	closeModal: (modalType: string) => dispatch(closeModal(modalType)),
	closeConfirmationModal: () => dispatch(closeModal()),
	getOfficeServiceGroups: (officeId) => dispatch(getOfficeServiceGroups(officeId, true)),
	getBookingTemplatesByOffice: (officeId) =>
		dispatch(getBookingTemplatesByOffice(officeId, true, undefined, undefined, undefined, true)),
	getDiscountStrategies: (shopId) => {
		dispatch(getDiscountStrategies(shopId));
	},
	getBookingAvailability: (bookingItems: IFormAddBookingItemRequest[]) =>
		dispatch(getBookingAvailability(bookingItems)),
	getShopOrder: (id: string) => dispatch(getShopOrder(id)),
	getOneShopCustomer: (customerId) => dispatch(getOneShopCustomer(customerId)),
	getBookingTemplatesById: (bookingTemplateId: string, loadResources: boolean, loadChildrenBookingTemplates: boolean) =>
		dispatch(getBookingTemplatesById(bookingTemplateId, loadResources, false, loadChildrenBookingTemplates)),

	getAppointments: () => dispatch(getAppointments(undefined, true, undefined)),
	manualBookingGetShoppingBasket: () => dispatch(manualBookingGetShoppingBasket()),
	addManualBookingItemToShoppingCart: (firstBookingItem: IAddBookingItemRequest) =>
		dispatch(addManualBookingItemToShoppingCart(firstBookingItem)),
	addAppointmentNoteOnShopOrder: (shopOrder: IShopOrder) =>
		dispatch(updateAppointmentsOnShopOrder(shopOrder, undefined, undefined, undefined, false)),
	createManualOrder: (customer: ICustomer, currencyKey: number, orderRequestData?: Partial<IManualOrderRequest>) =>
		dispatch(createManualOrder(customer, currencyKey, orderRequestData)),
	clearCartFormData: () => dispatch(clearFormData()),
	clearAppointmentsErrors: () => dispatch(clearAppointmentsErrors()),
	manualBookingUpdateShoppingBasket: (shoppingBasketId: string, bookingItemsToAdd: IFormAddBookingItemRequest[]) =>
		dispatch(manualBookingUpdateShoppingBasket(shoppingBasketId, bookingItemsToAdd)),
	updateAppointmentsOnShopOrderEdit: (
		shopOrder: IShopOrder,
		itemsToUpdate: BookingItemToUpdateRequest[],
		itemsToRemove: string[],
		itemsToAdd: IAddBookingItemRequest[],
	) => dispatch(updateAppointmentsOnShopOrder(shopOrder, itemsToUpdate, itemsToRemove, itemsToAdd, false)),
	clearShoppingBasket: () => dispatch(clearShoppingBasket(false)),
	addEditBatchDiscountStrategies: (discountStrategies: IDiscountStrategy[], groupId: string, shopId: string) =>
		dispatch((dispatch, getState) =>
			addEditBatchDiscountStrategies(dispatch, getState, shopId, discountStrategies, groupId),
		),
	groupRecurringAppointments: (orderItems: IOrderItem[]) => dispatch(groupRecurringAppointments(orderItems)),
	// TODO: note translation that tells the customer their order was created again
	rejectShopOrder: (shopOrder: IShopOrder, note?: string) =>
		dispatch(setStatus(shopOrder.id, shopOrder.shopId, OrderStatus.Rejected, note)),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	updateShopCustomer: (newData: Partial<ICustomer>) => dispatch(updateShopCustomer(newData, false)),
});

export const ManualBookingModal = connect(
	stateToProps,
	dispatchToProps,
)(
	reduxForm({
		form: c.FORM_NAME_MANUAL_BOOKING_PLAN,
		enableReinitialize: true,
		keepDirtyOnReinitialize: true,
	})(ManualBookingModalComponent),
);
